export const isAuthenticated = (state) => {
    console.log("state authe",state)
    if (state.localStore.token) return true;
    return false;
};
